import { Injectable } from 'angular-ts-decorators';

import { Observable, fromEvent } from 'rxjs';

/**
 *
 * Service that expose keyup$ stream that emits every time when respective
 * events happen
 */
@Injectable('keyStreams')
export class KeyStreams {
  /**
   * Stream; emits the whole event object every time when key is
   * released & keyup emited
   */
  keyup$: Observable<Event>;
  /**
   * Stream; emits the whole event object every time when key is
   * released & keydown emited
   */
  keydown$: Observable<Event>;

  constructor(private $window: ng.IWindowService) {
    'ngInject';

    this.keyup$ = fromEvent($window, 'keyup');
    this.keydown$ = fromEvent($window, 'keydown');
  }
}
